export default "__VITE_ASSET__DJx2jjMa__"